/*********************************************************
 *                  Admin liste user Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminToolsCtrl", ["$http", "$scope", "toastr", "clients", "ENV", "ExploitationService", function ($http, $scope, toastr, clients, ENV, ExploitationService) {
		$scope.data = {
			clients: clients.data,
			mapMatching : "CAR"
		};

		$scope.data.clients = $scope.data.clients.filter(
			c => c.code.indexOf("mobiiti_") !== 0 &&
				c.code.indexOf("technique") !== 0);

		if ($scope.data.clients.length > 0) {
			$scope.selectedClient = $scope.data.clients[0];
		}


		$scope.loadLinesBySchema = function () {
			if ($scope.selectedClient) {
				ExploitationService.getAllLinesBySchema($scope.selectedClient.code).then((response) => {
					$scope.data.lines = response.data;
				})
			}
		}

		$scope.loadLinesBySchema();


		$scope.launchTraceInitialization = async function () {
			toastr.success("", "Initialisation des tracés lancée");
			if ($scope.selectedClient === undefined || $scope.selectedClient === '') {
				toastr.error("", "Veuillez sélectionner une organisation");
				return;
			}
			for (let line of $scope.data.lines) {
				line.success = undefined;
				line.loading = true;



				try {
					const req = await doRequest(line);
					line.loading = false;
					line.success = true;

				}catch (e) {
					line.loading = false;
					line.success = false;
					toastr.error(e ? e.message : "", "Problème lors du lancement de l'initialisation des tracés");
				}

			}
			$scope.$apply();
		};


		function doRequest(line) {
			const url  = ENV.API_URL + "/fix/" + $scope.selectedClient.code + "/" + line.id + "/generate-geojson-all-journey-patterns-by-line?type=" + $scope.data.mapMatching;
			return $http.get(url);
		}



	}]);

